// extracted by mini-css-extract-plugin
export default {"wrapper":"UserIcon_wrapper__bzikH","small":"UserIcon_small__1mHxd","avatar":"UserIcon_avatar__oOUxm"};